import { TransformDefinitionSet } from "./transformationDefinition";
import { AlertManager } from "react-alert";
import { makeRequest } from "../util";
import {
  GetTransformationSetsResponse,
  TransformationPageFilter,
  TransformationPageSort,
} from "./types";
import _ from "lodash";
import * as Sentry from "@sentry/browser";
export const loadTransforms = (
  setAllTransformationSets: (
    value:
      | ((prevState: TransformDefinitionSet[]) => TransformDefinitionSet[])
      | TransformDefinitionSet[]
  ) => void,
  setLoaded?: (value: ((prevState: boolean) => boolean) | boolean) => void,
  alert?: AlertManager
): void => {
  makeRequest<any>("get_transformation_sets", {})
    .then((response: { data: GetTransformationSetsResponse }) => {
      setAllTransformationSets(
        _.map(response.data, (setData) => new TransformDefinitionSet(setData))
      );
      setLoaded && setLoaded(true);
    })
    .catch((error: string) => {
      alert && alert.error("Something went wrong. Unable to load page.");
      console.log(error);
      Sentry.captureException(error);
    });
};

export const organizeTransformations = (
  allTransformations: TransformDefinitionSet[],
  options: {
    filter?: TransformationPageFilter | null;
    sort?: TransformationPageSort | null;
    includeAll?: boolean;
  }
): TransformDefinitionSet[] => {
  const { filter, sort, includeAll = false } = options;
  let result = [...allTransformations];

  if (filter) {
    result = _.filter(result, (set) =>
      set.matchesFilter(filter.type, filter.value, includeAll)
    );
  }

  if (sort) {
    result = _.orderBy(
      result,
      [sort.column, "createdAt"],
      [sort.direction, sort.direction]
    );
  }

  return result;
};
